<template>
  <div class="el-main" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="AIがあなたに最適なテキストを生成しています">
    <!-- <div class="card"
    v-show="currentCardId == 'occupation'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職種</h2>
        <p>後の入力項目で選択した職種に合わせた例文が使えます</p>
      </div>
      <div class="card-content">
        <div>
        <el-select v-model="formatData.occupation"
          placeholder="Select">
          <el-option v-for="item in occupationOptions"
            :key="item.value"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select>
        </div>
      </div>
    </div>
  </div> -->

    <div class="card" v-show="currentCardId == 'job-summary'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>職務要約</h2>
          <p>自分の職務経歴を100～150文字程度でわかりやすくまとめましょう</p>
          <div class="add-item">
            <el-button @click="$modal.show('summary-dialog')" type="success">例文から追加</el-button>
            <el-button @click="showAiSummaryDialog()" id="prime-reasonai-btn"
              type="danger">最新のAIを使う</el-button>
          </div>
        </div>
        <div class="card-content">
          <modal name="summary-dialog" :adaptive="true" :scrollable="true" height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('summary-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="title">例文を選ぶ</div>
            <div class="description">
              <p>選択した例文が追加されます。</p>
              <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, index) in filtered(exampleSentences.summary)"
                v-on:click="formatData.jobSummary = item.sentences.replace(/<br>/ig, '\n'); $modal.hide('summary-dialog')"
                :key="index">
                <div class="title">{{ item.name }}</div>
                <div class="body" v-html="item.sentences"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('summary-dialog')">閉じる</el-button>
            </div>
          </modal>

          <modal name="ai-summary-dialog" :adaptive="true" :scrollable="true" height="auto" @before-close="cancelAIStream">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('ai-summary-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <p
              style="display: inline-block; font-size: 0.7rem; font-weight: bold; color: #fff; background: #0F9934; border-radius: 15px; padding: 2px 10px; margin-bottom: 5px;">
              ヤギプライム機能</p>
            <div class="title">AIに職務要約を書いてもらう</div>
            <div class="description">
              <p v-if="!aiSummaryResultView">AIがあなたの職務要約を作成してくれます。</p>
              <p class="attention" v-if="aiSummaryResultView">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
            </div>
            <div v-if="!aiSummaryResultView">
              <div class="text-center" style="margin-top: 10px;" v-show="!aiIsStreaming">
                <p style="font-size: 0.8rem;"><span>利用回数：{{ aiUsageCount }} / {{ aiMaxUsageCount }}回</span></p>
                <el-button @click="getAISummary()"
                  style="color: #fff; background-color: #e3165c; border-color: #e3165c;">下記の内容でAI職務要約を作成</el-button>
              </div> <!---->

              <ul class="example-sentence">
                <li>
                  <div class="title">スキル</div>
                  <div class="el-textarea" style="font-size: 12px;">
                    <dl v-for="(item, index) in formatData.skillsToUse" :key="index">
                      <dt>{{ item.skillname }} <template v-if="item.years">/ 実務経験 {{ item.years }}年以上</template></dt>
                    </dl>
                  </div>
                </li>
                <li>
                  <div class="title">職務経歴</div>
                  <div class="el-textarea" style="font-size: 12px;">
                    <div v-for="item in formatData.jobHistories" :key="item.uuid">
                      <h4>{{ item.companyName }}：<span v-if="item.isContinuing && item.startYear && item.startMonth">{{
                        item.startYear }}年 {{
                            item.startMonth }}月 〜 在職中</span>
                        <span v-else-if="item.isContinuing && item.startYear && !item.startMonth">{{ item.startYear }}年
                          〜
                          在職中</span>
                        <span v-else-if="item.isContinuing && !item.startYear && item.startMonth">{{ item.startMonth }}月
                          〜 在職中</span>
                        <span v-else-if="item.isContinuing && !item.startYear && !item.startMonth">在職中</span>
                        <span v-else><template v-if="item.startYear">{{ item.startYear }}年</template> <template
                            v-if="item.startMonth">{{ item.startMonth }}月</template> <template
                            v-if="item.endYear || item.endMonth">〜</template> <template v-if="item.endYear">{{
                              item.endYear }}年</template> <template v-if="item.endMonth">{{ item.endMonth
                            }}月</template></span>
                      </h4>
                      <!-- <h3>{{ item.companyName }}<span>{{ item.startYear}}年{{ item.startMonth }}月 〜 現在に至る</span></h3> -->
                      <div v-for="(item, index) in item.projects" :key="index" :style="formatData.selFontStyle">
                        <h5
                          v-if="item.projectTitle || item.startYear || item.startMonth || item.endYear || item.endMonth">
                          {{ item.projectTitle }}：<span><template v-if="item.startYear">{{ item.startYear }}年</template>
                            <template v-if="item.startMonth">{{ item.startMonth }}月</template> <template
                              v-if="item.endYear || item.endMonth">〜</template> <template v-if="item.endYear">{{
                                item.endYear }}年</template> <template v-if="item.endMonth">{{ item.endMonth
                              }}月</template></span></h5>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div v-else>
              <div v-if="aiIsThinking" class="ai-thinking" @click="toggleAiReasoning">
                <span class="ai-thinking__icon"></span>
                <span class="ai-thinking__label">{{ aiThinkingLabel }}</span>
                <span class="ai-thinking__dots">
                  <span class="ai-thinking__dot"></span>
                  <span class="ai-thinking__dot"></span>
                  <span class="ai-thinking__dot"></span>
                </span>
              </div>
              <div v-if="aiReasoningText" class="ai-reasoning" :class="aiShowReasoning ? 'ai-reasoning--expanded' : 'ai-reasoning--collapsed'">
                <div class="ai-reasoning__content">{{ aiReasoningText }}</div>
              </div>
              <div v-if="!aiIsThinking && aiReasoningText" class="ai-reasoning__toggle" @click="toggleAiReasoning">
                <span class="ai-reasoning__arrow" :class="{ 'ai-reasoning__arrow--open': aiShowReasoning }">▶</span>
                {{ aiShowReasoning ? '思考過程を隠す' : '思考過程を見る' }}
              </div>
              <ul class="example-sentence">
                <li
                  v-on:click="!aiIsStreaming && (formatData.jobSummary = aiResultSummaryResult.replace(/<br>/ig, '\n'), $modal.hide('ai-summary-dialog'), aiResultView = false)">
                  <div class="title">AIからの提案</div>
                  <div class="body"><span v-html="aiResultSummaryResult"></span><span v-if="aiIsStreaming && !aiIsThinking" class="ai-cursor"></span></div>
                </li>
              </ul>
              <div v-if="!$globalVar.isYagiPrime" class="text-right" style="margin-top: 10px;" v-show="!aiIsStreaming">全文を表示する場合は／<br>
                <el-button @click="goYagiprimeRegisterSummary" id="prime-reasonai-register-btn"
                  v-if="$globalVar.in_app_payments"
                  style="color: #fff; background-color: #e3165c; border-color: #e3165c;">ヤギプライム会員になる</el-button>
              </div> <!---->
            </div>
            <div class="text-right" v-show="!aiIsStreaming">
              <el-button @click="$modal.hide('ai-summary-dialog')">閉じる</el-button>
            </div>
          </modal>
          <el-input type="textarea" v-model="formatData.jobSummary" :autosize="{ minRows: 5, maxRows: 15 }"></el-input>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'skills-to-use'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>活かせるスキル・経験</h2>
          <p>応募先にアピールできるスキル（技能）や資格、経験などを入力しましょう</p>
        </div>
        <div class="card-content-list">
          <div class="edit-form-list">
            <div class="add-item">
            </div>
            <transition-group name="fade" tag="div">
              <history-item-skill v-on:add-history-item="addSkillHistory" v-on:delete-history-item="deleteSkillHistory"
                v-on:move-history-item="moveSkillHistory" v-for="(item, index) in formatData.skillsToUse"
                @click.native="activateHistoryItem(item.uuid)" :item="item" :length="formatData.skillsToUse.length"
                :index="index" :key="item.uuid" :id="item.uuid" :class="{ 'active': activeHistoryItem == item.uuid }"
                :ref="'SkillHistory_' + index" :minYear="basicData.birthYear" :createDate="formatData.createDate"
                :descriptionPlaceholder="' スキルや資格の名称を入力'" :descriptionPlaceholder2="' 習熟度や説明を入力'"
                :descriptionMaxLength="descriptionMaxLength"></history-item-skill>
            </transition-group>
            <div class="add-list-item">
              <el-button icon="el-icon-plus" circle type="success" @click="addSkillHistory()"></el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'job-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>職務経歴</h2>
          <p>今までに在籍した会社の概要を入力しましょう。<br>職種ごとに、業務の実績や参加プロジェクトの説明も追加できます。</p>
          <!--<el-checkbox v-model="formatData.notDisplayOmonajiseki">【主な実績】のラベルを表示しない</el-checkbox>-->
          <!-- <div v-for="(item, index) in formatData.jobHistories"> -->
          <!-- {{item.uuid}} -->
          <!-- <div v-for="(item2, index2) in item.projects">_{{item2.uuid}}</div> -->
          <!-- </div> -->
        </div>
        <div class="card-content-list">
          <div class="edit-form-list">
            <transition-group name="fade" tag="div">
              <history-item v-on:add-history-item="addJobHistory" v-on:delete-history-item="deleteJobHistory"
                v-on:move-history-item="moveJobHistory" v-on:add-project-history-item="addProjectHistory"
                v-on:delete-history-item-detail="deleteHistoryDetail"
                v-on:move-history-item-detail="moveJobHistoryDetail" v-for="(item, index) in formatData.jobHistories"
                @click.native="activateHistoryItem(item.uuid)" :item="item" :length="formatData.jobHistories.length"
                :index="index" :key="item.uuid" :id="item.uuid" :class="{ 'active': activeHistoryItem == item.uuid }"
                :ref="'JobHistory_' + index" :minYear="basicData.birthYear" :createDate="formatData.createDate"
                :activeHistoryItem="activeHistoryItem" :descriptionPlaceholder="'会社名を入力'"
                :descriptionMaxLength="descriptionMaxLength">
              </history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button icon="el-icon-plus" circle type="success" @click="addJobHistory()"></el-button>
              <!--
            <el-button icon="el-icon-plus"
                       circle
                       type="success"
                       @click="addProjectHistory()"></el-button>
            -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'pr-message'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>自己PR</h2>
          <p>書類審査、合格のカギは志望動機と自己PRの表現力！最新のAIを使って表現力アップ！</p>
          <div class="add-item">
            <el-button @click="$modal.show('pr-dialog')" type="success">例文から追加</el-button>
            <el-button @click="showAiMyprDialog()" id="prime-reasonai-btn" type="danger">最新のAIを使う</el-button>
          </div>
        </div>
        <div class="card-content">
          <modal name="pr-dialog" :adaptive="true" :scrollable="true" height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('pr-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="title">例文を選ぶ</div>
            <div class="description">
              <p>選択した例文が追加されます。</p>
              <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, index) in filtered(exampleSentences.prMessage)"
                v-on:click="formatData.prMessage = item.sentences.replace(/<br>/ig, '\n'); $modal.hide('pr-dialog')"
                :key="index">
                <div class="title">{{ item.name }}</div>
                <div class="body" v-html="item.sentences"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('pr-dialog')">閉じる</el-button>
            </div>
          </modal>
          <modal name="ai-mypr-dialog" :adaptive="true" :scrollable="true" height="auto" @before-close="cancelAIStream">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('ai-mypr-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <p
              style="display: inline-block; font-size: 0.7rem; font-weight: bold; color: #fff; background: #0F9934; border-radius: 15px; padding: 2px 10px; margin-bottom: 5px;">
              ヤギプライム機能</p>
            <div class="title">AIに自己PRを書いてもらう</div>
            <div class="description">
              <p>4つの質問に答えるだけで、AIがあなたの自己PRを作成してくれます。</p>
              <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
            </div>
            <div v-if="!aiResultView">
              <ul class="example-sentence">
                <li>
                  <div class="title">Q.1 あなたの長所と短所</div>
                  <div class="el-textarea">
                    <div class="flex" style="margin-top: 10px; align-items: center;">
                      <span style="width: 10%; font-size: 0.8rem;">長所</span>
                      <el-input type="textarea" autosize placeholder="" title="長所" autocomplete="off"
                        v-model="formatData.ai_mypr_good"></el-input>
                    </div>
                    <div class="flex" style="margin-top: 10px; align-items: center;">
                      <span style="width: 10%; font-size: 0.8rem;">短所</span>
                      <el-input type="textarea" autosize placeholder="" title="短所" autocomplete="off"
                        v-model="formatData.ai_mypr_bad"></el-input>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="title">Q.2 あなたの趣味</div>
                  <div class="el-textarea">
                    <el-input type="textarea" autosize placeholder="" title="あなたの趣味" autocomplete="off"
                      v-model="formatData.ai_mypr_hobby"></el-input>
                  </div>
                </li>
                <li>
                  <div class="title">Q.3 今後やりたいこと</div>
                  <div class="el-textarea">
                    <el-input type="textarea" autosize placeholder="" title="今後やりたいこと" autocomplete="off"
                      :autosize="{ minRows: 3, maxRows: 15 }" v-model="formatData.ai_mypr_wanted"></el-input>
                  </div>
                </li>
                <li>
                  <div class="title">Q.4 その他アピールしたいこと</div>
                  <div class="el-textarea">
                    <el-input type="textarea" autosize placeholder="" title="その他アピールしたいこと" autocomplete="off"
                      :autosize="{ minRows: 3, maxRows: 15 }" v-model="formatData.ai_mypr_appeal"></el-input>
                  </div>
                </li>
              </ul>
              <div class="text-right" style="margin-top: 10px;" v-show="!aiIsStreaming">
                <p style="font-size: 0.8rem;"><span>利用回数：{{ aiUsageCount }} / {{ aiMaxUsageCount }}回</span></p>
                <el-button @click="getAIMypr()"
                  style="color: #fff; background-color: #e3165c; border-color: #e3165c;">この内容でAI自己PRを作成</el-button>
              </div> <!---->
            </div>
            <div v-else>
              <div v-if="aiIsThinking" class="ai-thinking" @click="toggleAiReasoning">
                <span class="ai-thinking__icon"></span>
                <span class="ai-thinking__label">{{ aiThinkingLabel }}</span>
                <span class="ai-thinking__dots">
                  <span class="ai-thinking__dot"></span>
                  <span class="ai-thinking__dot"></span>
                  <span class="ai-thinking__dot"></span>
                </span>
              </div>
              <div v-if="aiReasoningText" class="ai-reasoning" :class="aiShowReasoning ? 'ai-reasoning--expanded' : 'ai-reasoning--collapsed'">
                <div class="ai-reasoning__content">{{ aiReasoningText }}</div>
              </div>
              <div v-if="!aiIsThinking && aiReasoningText" class="ai-reasoning__toggle" @click="toggleAiReasoning">
                <span class="ai-reasoning__arrow" :class="{ 'ai-reasoning__arrow--open': aiShowReasoning }">▶</span>
                {{ aiShowReasoning ? '思考過程を隠す' : '思考過程を見る' }}
              </div>
              <ul class="example-sentence">
                <li
                  v-on:click="!aiIsStreaming && (formatData.prMessage = aiResultMyprResult.replace(/<br>/ig, '\n'), $modal.hide('ai-mypr-dialog'), aiResultView = false)">
                  <div class="title">AIからの提案</div>
                  <div class="body"><span v-html="aiResultMyprResult"></span><span v-if="aiIsStreaming && !aiIsThinking" class="ai-cursor"></span></div>
                </li>
              </ul>
              <div v-if="!$globalVar.isYagiPrime" class="text-right" style="margin-top: 10px;" v-show="!aiIsStreaming">全文を表示する場合は／<br>
                <el-button @click="goYagiprimeRegister" id="prime-reasonai-register-btn"
                  v-if="$globalVar.in_app_payments"
                  style="color: #fff; background-color: #e3165c; border-color: #e3165c;">ヤギプライム会員になる</el-button>
              </div> <!---->
            </div>
            <div class="text-right" v-show="!aiIsStreaming">
              <el-button @click="$modal.hide('ai-mypr-dialog')">閉じる</el-button>
            </div>
          </modal>
          <el-input type="textarea" v-model="formatData.prMessage" :autosize="{ minRows: 6, maxRows: 15 }"></el-input>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'create-date'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>職務経歴書の作成日を入力</h2>
          <p>実際に書類を持参する日、または郵送する日を選びましょう</p>
        </div>
        <div class="card-content">
          <div class="edit-form-list">
            <div class="create-date-action">
              <div class="action-item">
                <el-button class="button-block"
                  :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getToday())"
                  @click="formatData.createDate = $formLib.getToday()">今日の日付を入力</el-button>
              </div>
              <div class="action-item">
                <el-button class="button-block"
                  :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getTommorow())"
                  @click="formatData.createDate = $formLib.getTommorow()">明日の日付を入力</el-button>
              </div>
              <div class="action-item">
                <el-date-picker v-model="formatData.createDate" type="date" :clearable="false" placeholder="選択してください"
                  :format="'yyyy年M月d日'" ref="create_date">
                </el-date-picker>
              </div>
            </div>
          </div>
          <br>
          <div v-if="false">
            <el-collapse accordion v-model="activeName" v-if="formatId != 'rirekisho_esf_challenged'">
              <el-collapse-item name="1">
                <template slot="title">
                  <div class="yagitaku">
                    <span class="yagitaku_recommend">ヤギのオススメ</span>あなたの大切な履歴書を確実にお届け
                  </div>
                </template>
                <div class="el-collapse-item__content">
                  <div class="bnr_item create-date_bnr">
                    <div class="bnr_txt create-date_txt">
                      <el-button
                        style="width:100%;border:0px;padding:20px;color: #fff;background:#E3165C;font-size: 1.1rem;"
                        :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled" @click="sendQuickmailLP">
                        <h3 style="color:#fff">Yagishに<br>履歴書を郵送してもらう</h3>
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="2" v-show="false">
                <template slot="title">
                  <div class="yagitaku">
                    <span class="yagitaku_recommend">オススメ</span>印刷から郵送まであなたの代わりに！ヤギの宅配便サービス
                  </div>
                </template>
                <div class="el-collapse-item__content">
                  <p>就職または転職を考えている企業先に、あなたの代わりにヤギッシュが「履歴書」「送付状」「封筒」を印刷して郵送いたします。（職務経歴書は自由選択）</p>

                  <div class="bnr_item create-date_bnr">
                    <div class="bnr_txt create-date_txt">
                      <el-button
                        style="width:100%;border:0px;padding:20px;background: #EFF8F8;color:#E3165C;font-size: 1.1rem;"
                        :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                        @click="$eventHub.$emit('send-special-post', formatId);">
                        <h3>ヤギの宅配便<span>をつかう</span></h3>
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'confirm'">
      <div class="overflow-scroll-y">
        <div class="card-header" style="max-width: 40rem;margin: 2rem auto -3rem;">
          <h2>作成した職務経歴書を確認</h2>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'output'" v-if="getMode != 'production1'">

      <download-item :formatId="formatId" :isSendYagiPostEnabled="isSendYagiPostEnabled"
        :isSendYagiEmailEnabled="isSendYagiEmailEnabled" :mailPdfEnabled="mailPdfEnabled"
        :downloadPdfEnabled="downloadPdfEnabled" :downloadActiveCollapses="downloadActiveCollapses"></download-item>
    </div>

  </div>
</template>
<style lang="scss" scoped>
.addition {
  font-size: .75rem;
  margin: .5rem 0;
}

* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}

.next_bnr {
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);
  padding: 30px;
}

.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img {
  border-radius: 10px 10px 0 0;
}

.bnr_txt {
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}

.txt {
  border-radius: 10px;
}

.bnr_txt p {
  font-size: 0.8rem;
  font-weight: bold;

}

.bnr_txt h3 {
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}

.create-date_txt {
  border-radius: 10px;
}

.bnr_note {
  font-size: 0.8rem;
}

.card-header h1 {
  padding-bottom: 1.5rem;
}

.card-header h2 {
  padding-bottom: 1.5rem;
}

/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}

/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}
</style>

<style lang="scss" scoped>
.yagitaku {
  line-height: 25px;
  padding: 15px 0;
  font-weight: bold;
}

.yagitaku_recommend {
  color: #fff;
  background: #E3165C;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}

.yagitaku_link {
  color: #E3165C;
  border-bottom: 1px solid #E3165C;
}

.create-date_bnr {
  margin: 15px 0;
}

.el-button--success.overwrite.overwrite,
.el-button--primary.overwrite {
  color: #000;
  background: #EFF8F8;
  border: none;
  display: block;
  padding: 0;
  border-radius: 15px;
  white-space: normal;
  line-height: 1.8;
}

.el-button--success.overwrite.overwrite:hover,
.el-button--primary.overwrite:hover {
  background: none;
  color: #000;
}

.addition {
  font-size: .75rem;
  margin: .5rem 0;
}

* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}

.next_bnr {
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);
  padding: 30px;
}

.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img {
  border-radius: 10px 10px 0 0;
}

.bnr_txt {
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}

.txt {
  border-radius: 10px;
}

.bnr_txt p {
  font-size: 0.8rem;
  font-weight: bold;

}

.bnr_txt h3 {
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}

.create-date_txt {
  border-radius: 10px;
}

.bnr_note {
  font-size: 0.8rem;
}

.card-header h1 {
  padding-bottom: 1.5rem;
}

.card-header h2 {
  padding-bottom: 1.5rem;
}

/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}

/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}
</style>
<script>
// import HistoryItem from './RirekishoParts/HistoryItem'
import DownloadItem from './CommonParts/DownloadItem'
import HistoryItemSkill from './ShokurekishoParts/HistoryItemSkill'
import HistoryItemJob from './ShokurekishoParts/HistoryItemJob_career'
// import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
// import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import aiStreamingMixin from '@/mixins/ai-streaming-mixin'
import '@/assets/css/ai-streaming.css'
import LoginForms from '@/components/LoginSpecialForms'

const uuidv4 = function () {
  const cryptoObj = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
const SkillHistoryData = function (columns) {
  this.skillname = columns.skillname || ''
  this.years = Number(columns.years) || ''
  this.description = columns.description || ''
  this.uuid = uuidv4()
}
// const SkillHistoryData2 = class sh {
//   constructor (columns) {
//     this.skillname = columns.skillname || ''
//     this.years = Number(columns.years) || ''
//     this.description = columns.description || ''
//     this.uuid = uuidv4()
//   }
//   run () {
//     return (this.uuid)
//   }
// }
const JobHistoryData = function (columns) {
  this.companyName = columns.companyName || ''
  this.startYear = Number(columns.startYear) || ''
  this.startMonth = Number(columns.startMonth) || ''
  this.endYear = Number(columns.endYear) || ''
  this.endMonth = Number(columns.endMonth) || ''
  this.isContinuing = columns.isContinuing || false
  this.capitalStock = columns.capitalStock || ''
  this.numberOfEmployees = columns.numberOfEmployees || ''
  this.businessArea = columns.businessArea || ''
  this.projects = columns.projects || []
  this.uuid = uuidv4()
}
const ProjectHistoryData = function (columns) {
  this.projectTitle = columns.projectTitle || ''
  this.startYear = Number(columns.startYear) || ''
  this.startMonth = Number(columns.startMonth) || ''
  this.endYear = Number(columns.endYear) || ''
  this.endMonth = Number(columns.endMonth) || ''
  this.contentsOfProject = columns.contentsOfProject || ''
  this.envAndScale = columns.envAndScale || ''
  this.position = columns.position || ''
  this.uuid = uuidv4()
}

export default {
  name: 'ShokurekishoEdit',
  props: {
    basicData: {
      type: Object,
      require: true
    },
    formatId: {
      type: String
    },
    currentCardId: {
      type: String
    },
    exampleSentences: {
      type: Object
    }
  },
  mixins: [LocalDataMixin, aiStreamingMixin],
  components: {
    'history-item': HistoryItemJob,
    'download-item': DownloadItem,
    'history-item-skill': HistoryItemSkill,
    // 'auto-job-histories': AutoJobHistories,
    'login-forms': LoginForms
  },
  data: function () {
    return {
      fullscreenLoading: false,
      aiResultView: false,
      aiSummaryResultView: false,
      aiResultMyprResult: '',
      aiResultSummaryResult: '',
      aiUsageCount: 0,
      aiMaxUsageCount: 1,
      saveName: 'shokumukeirekisho',
      saveOtherName: 'rirekisho',
      formatData: {
        createDate: null,
        occupation: 'others',
        jobSummary: '',
        experienceAndKnowledge: '',
        skillsToUse: [],
        jobHistories: [],
        licenseHistories: [],
        prMessage: '',
        hopeJobcategory: ''
      },
      activeName: '1',
      isWeekEndFlag: true,
      activeHistoryItem: '',
      descriptionMaxLength: 80,
      mailPdfEnabled: true,
      downloadPdfEnabled: true,
      isSendYagiPostEnabled: true,
      isSendYagiEmailEnabled: true,
      eprintPdfEnabled: true,
      downloadActiveCollapses: ['postcard'],
      occupationOptions: [
        {
          value: 'engineer',
          label: 'エンジニア'
        },
        {
          value: 'sales',
          label: '営業'
        },
        {
          value: 'backoffice',
          label: '事務'
        },
        {
          value: 'others',
          label: 'その他'
        }
      ]
    }
  },
  computed: {
    previewErrors: function () {
      if (!this.previewFormat || !this.previewFormat.errorMessages) return {}
      return this.previewFormat.errorMessages
    },
    optionItems: function () {
      if (!this.previewFormat || !this.previewFormat.optionItems) return {}
      return this.previewFormat.optionItems
    },
    isMynabi: function () {
      return (this.$yagi.isFromMynabi === 1)
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  watch: {
    formatData: function () {
      // console.log(this.formatData.jobHistories.length)
      if (this.formatData.jobHistories.length === 0) {
        // this.addJobHistory()
        // this.addProjectHistory(0)
        // this.createProjectHistoryItem()
        // console.log('asdf')
      }
    }
  },
  methods: {
    fetchAiUsageCount: function (categoryType) {
      if (!this.$firebase || !this.$firebase.isAuthenticated) return Promise.resolve()
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('category_type', categoryType)
      return this.$axios.post(this.$varuna.endPoints.getAiUsageCount, formData).then((response) => {
        if (response.data.success) {
          this.aiUsageCount = response.data.usage_count || 0
          this.aiMaxUsageCount = this.$globalVar.isYagiPrime ? 10 : 1
        }
      })
    },
    showAiSummaryDialog: function () {
      this.fetchAiUsageCount('summary').finally(() => {
        this.$modal.show('ai-summary-dialog')
      })
    },
    showAiMyprDialog: function () {
      this.fetchAiUsageCount('pr').finally(() => {
        this.$modal.show('ai-mypr-dialog')
      })
    },
    goYagiprimeRegisterSummary: function () {
      const app = this

      app.$cookies.config(60 * 60 * 24, '')
      const route_id = app.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
      app.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', route_id + '#self_summary_shokumu', null, null, 'yagish.jp')
      app.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', route_id + '#self_summary_shokumu', null, null, 'localhost')
      location.href = '/yagiprime_register'
    },
    goYagiprimeRegister: function () {
      const app = this

      app.$cookies.config(60 * 60 * 24, '')
      const route_id = app.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
      app.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', route_id + '#self_introduction_shokumu', null, null, 'yagish.jp')
      app.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', route_id + '#self_introduction_shokumu', null, null, 'localhost')
      location.href = '/yagiprime_register'
    },
    getAIMypr: function () {
      const app = this
      // 非プライム & 使用済みの場合は既存テキストを表示
      if (!this.$globalVar.isYagiPrime && this.aiUsageCount >= 1) {
        if (this.formatData.prMessage) {
          this.aiResultMyprResult = this.formatData.prMessage.replace(/\n/g, '<br>')
          this.aiResultView = true
          return
        }
      }
      const formData = new FormData()
      if (app.$firebase.isAuthenticated) {
        formData.append('uuid', this.$firebase.user.uid)
      }
      formData.append('education', '')
      formData.append('strength', this.formatData.ai_mypr_good)
      formData.append('weakness', this.formatData.ai_mypr_bad)
      formData.append('hobby', this.formatData.ai_mypr_hobby)
      formData.append('future', this.formatData.ai_mypr_wanted)
      formData.append('free', this.formatData.ai_mypr_appeal)

      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')

      this.startAIStream(this.$varuna.endPoints.aiIntroduce, formData, {
        resultField: 'aiResultMyprResult',
        viewField: 'aiResultView',
        onError: (error) => {
          const message = error.message || '失敗しました'
          if (message === 'AIの使用回数が上限に達しました。') {
            app.$eventHub.$emit('show-yagiprime-payment-dialog', 'self-introduction-shokumu')
          }
        }
      })
    },
    getAISummary: function () {
      const app = this
      // 非プライム & 使用済みの場合は既存テキストを表示
      if (!this.$globalVar.isYagiPrime && this.aiUsageCount >= 1) {
        if (this.formatData.jobSummary) {
          this.aiResultSummaryResult = this.formatData.jobSummary.replace(/\n/g, '<br>')
          this.aiSummaryResultView = true
          return
        }
      }
      const formData = new FormData()
      if (app.$firebase.isAuthenticated) {
        formData.append('uuid', this.$firebase.user.uid)
      }
      formData.append('data', JSON.stringify(this.formatData.skillsToUse) + JSON.stringify(this.formatData.jobHistories))

      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')

      this.startAIStream(this.$varuna.endPoints.aiSummary, formData, {
        resultField: 'aiResultSummaryResult',
        viewField: 'aiSummaryResultView',
        onError: (error) => {
          const message = error.message || '失敗しました'
          if (message === 'AIの使用回数が上限に達しました。') {
            app.$eventHub.$emit('show-yagiprime-payment-dialog', 'self-summary-shokumu')
          }
        }
      })
    },
    filtered: function (obj) {
      const selectedOccupation = this.formatData.occupation
      return obj.filter(function (item) {
        return item.type === selectedOccupation
      })
    },
    sendQuickmailLP: function () {
      location.href = '/quickmail/info'
    },
    setJobHistories: function (historyList) {
      // 先頭から追加
      for (const key in historyList) {
        const item = historyList[key]
        this.addJobHistory(null, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    resetJobHistories: function () {
      this.formatData.jobHistories = []
    },
    createJobHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new JobHistoryData(columns)
    },
    createProjectHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new ProjectHistoryData(columns)
    },
    historySort: function (a, b) {
      let aYear = Number(a.year)
      let aMonth = Number(a.month)
      let bYear = Number(b.year)
      let bMonth = Number(b.month)
      if (aYear === bYear && aMonth === bMonth) {
        return 0
      }
      // 空欄は一番下に
      if (!aYear) aYear = 9999
      if (!aMonth) aMonth = 99
      if (!bYear) bYear = 9999
      if (!bMonth) bMonth = 99
      if (aYear > bYear) {
        return 1
      } else if (aYear < bYear) {
        return -1
      }
      if (aMonth > bMonth) {
        return 1
      } else if (aMonth < bMonth) {
        return -1
      }
      console.log('historySort failed')
      return 0
    },
    sortHistory: function (historyList) {
      // copy and sort
      return historyList.slice().sort(this.historySort)
    },
    addSkillHistory: function (index, columns) {
      const historyList = this.formatData.skillsToUse
      if (!columns) columns = {}
      const newHistoryItem = new SkillHistoryData(columns)
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    addJobHistory: function (index, columns) {
      const historyList = this.formatData.jobHistories
      if (!columns) columns = {}
      const newHistoryItem = new JobHistoryData(columns)
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    addProjectHistory: function (index, columns) {
      // const targetItem = this.formatData.jobHistories.find((item) => {
      //   return (item.uuid === this.activeHistoryItem)
      // })
      const targetItem = this.formatData.jobHistories[index]
      if (!columns) columns = {}
      const newHistoryItem = new ProjectHistoryData(columns)
      targetItem.projects.push(newHistoryItem)
    },
    moveSkillHistory: function (params) {
      this.moveHistory(this.formatData.skillsToUse, params)
    },
    moveJobHistory: function (params) {
      this.moveHistory(this.formatData.jobHistories, params)
    },
    moveJobHistoryDetail: function (params, parentIndex) {
      this.moveHistory(this.formatData.jobHistories[parentIndex].projects, params)
    },
    moveHistory: function (historyList, params) {
      const fromIndex = params.index
      const to = params.to
      if (fromIndex === 0 && to === 'up') {
        console.log('first item skip')
        return
      }
      if (fromIndex + 1 === historyList.length && to === 'down') {
        console.log('last item skip')
        return
      }
      if (to === 'up') {
        historyList.splice(fromIndex - 1, 2, historyList[fromIndex], historyList[fromIndex - 1])
      } else if (to === 'down') {
        historyList.splice(fromIndex, 2, historyList[fromIndex + 1], historyList[fromIndex])
      } else {
        console.log('param "to" must be "up" or "down"')
      }
    },
    deleteSkillHistory: function (index) {
      this.formatData.skillsToUse.splice(index, 1)
    },
    deleteJobHistory: function (index) {
      this.formatData.jobHistories.splice(index, 1)
    },
    deleteHistoryDetail: function (index, index2) {
      console.log(index, index2)
      this.formatData.jobHistories[index].projects.splice(index2, 1)
    },
    activateHistoryItem: function (id) {
      this.activeHistoryItem = id
    },
    deactivateHistoryItem: function () {
      this.activeHistoryItem = ''
    },
    dataChanged: function () {
      this.mailPdfEnabled = true
      this.downloadPdfEnabled = true
    }
  },
  created: function () {
    const nowdate = new Date()
    const date1 = new Date('2023/05/27 00:00:00')
    const date2 = new Date('2023/05/28 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isWeekEndFlag = true
    } else {
      this.isWeekEndFlag = false
    }
    if (this.getMode != 'production') {
      this.isWeekEndFlag = true
    }
  },
  beforeMount: function () {
    if (this.formatData.createDate === null) {
      this.formatData.createDate = this.$formLib.getToday()
    }
    this.$eventHub.$on('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
  }
}
</script>
<style scoped lang="scss"></style>
